export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp,image/gif";
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024;

export function validateImageFile(file: File) {
  if (!IMAGE_ACCEPT.split(",").includes(file.type)) {
    throw new Error("Choose a JPG, PNG, WebP, or GIF image.");
  }
  if (file.size > MAX_IMAGE_SIZE) {
    throw new Error("Image size must be 5 MB or less.");
  }
}

export function toMultipart(
  values: Record<string, string | number | boolean | null | undefined>,
  fileField: string,
  file?: File | null
) {
  const body = new FormData();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {body.append(key, String(value));}
  });
  if (file) {body.append(fileField, file);}
  return body;
}
